import api from './api';

const authService = {
  login: async (credentials) => {
    try {
      const response = await api.post('/auth/login', credentials);

      if (response.data.success) {
        localStorage.setItem('user', JSON.stringify(response.data.user));
      }

      return response.data;
    } catch (error) {
      throw error.response ? error.response.data : new Error('Error de conexión');
    }
  },

  logout: async () => {
    try {
      const response = await api.post('/auth/logout');

      localStorage.removeItem('user');

      return response.data;
    } catch (error) {
      throw error.response ? error.response.data : new Error('Error de conexión');
    }
  },

  checkAuth: async () => {
    try {
      const response = await api.get('/auth/check');



      return response.data;
    } catch (error) {
      localStorage.removeItem('user');
      throw error.response ? error.response.data : new Error('Error de conexión');
    }
  },


  getCurrentUser: () => {
    const userStr = localStorage.getItem('user');
    if (userStr && userStr !== 'undefined' && userStr !== 'null') {
      try {
        return JSON.parse(userStr);
      } catch (error) {
        console.error('Error parsing user data from localStorage:', error);
        localStorage.removeItem('user');
        return null;
      }
    }
    return null;
  },

  requiresShopSelection: () => {
    const user = authService.getCurrentUser();
    return user && (user.shopId === null || user.shopId === undefined);
  },

  isAuthenticated: () => {
    const user = authService.getCurrentUser();
    return user !== null && (user.shopId !== null && user.shopId !== undefined);
  },

  isAdmin: () => {
    const user = authService.getCurrentUser();
    return user && user.isAdmin === 1;
  },

  changeShop: async (shopId) => {
    try {
      const response = await api.post('/auth/change-shop', { shopId });

      if (response.data.success) {
        const currentUser = authService.getCurrentUser();
        const updatedUser = {
          ...currentUser,
          shopId: response.data.shopId,
          shopName: response.data.shopName
        };
        localStorage.setItem('user', JSON.stringify(updatedUser));
      }

      return response.data;
    } catch (error) {
      throw error.response ? error.response.data : new Error('Error de conexión');
    }
  },

  getAvailableShops: async () => {
    try {
      const user = authService.getCurrentUser();
      if (!user || !user.listsShops) return [];

      const shopIds = user.listsShops.split('|').filter(id => id !== '').map(id => parseInt(id));

      const response = await api.get('/utils/shops');
      if (response.data.success) {
        return response.data.shops.filter(shop => shopIds.includes(shop.shop_id));
      }
      return [];
    } catch (error) {
      throw error.response ? error.response.data : new Error('Error de conexión');
    }
  },

  hasMultipleShops: () => {
    const user = authService.getCurrentUser();
    if (!user || !user.listsShops) return false;

    const shopIds = user.listsShops.split('|').filter(id => id !== '');
    return shopIds.length > 1;
  }
};



export default authService;